import { navigate, taskPath } from '../OrbitDevelopmentApp.jsx';

/**
 * The nudge: other open tasks that name a file this one also names.
 *
 * Advisory only. It never disables anything and never groups anything — it asks a person to
 * look before starting both at once, and there is nothing to press.
 */
export default function OverlapNotice({ overlaps }) {
  if (!overlaps?.length) return null;

  const shared = [...new Set(overlaps.flatMap(o => o.shared || []))];

  return (
    <div className="o-hint" style={{
      border: '1px solid var(--rule)', borderLeft: '2px solid var(--brass)',
      borderRadius: 'var(--r-md)', background: 'var(--brass-wash)',
      padding: '10px 14px', margin: '0 0 16px',
    }}>
      <b>Shares files with {overlaps.length} other open {overlaps.length === 1 ? 'task' : 'tasks'}.</b>{' '}
      Worth reading before starting both at once.
      <ul style={{ margin: '6px 0 0', paddingLeft: 18 }}>
        {overlaps.map(o => (
          <li key={o.id} style={{ marginTop: 2 }}>
            <button type="button" className="o-btn o-btn-ghost o-btn-sm"
              style={{ padding: 0, border: 0, background: 'none', height: 'auto' }}
              onClick={() => navigate(taskPath(o.id))}>{o.title}</button>
            {' — '}
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: '.6875rem' }}>
              {(o.shared || []).join(', ')}
            </span>
          </li>
        ))}
      </ul>
      {shared.length > 3 && (
        <span className="o-note" style={{ display: 'block', marginTop: 4 }}>
          {shared.length} shared entries in total.
        </span>
      )}
    </div>
  );
}
